import { useEffect, useRef, useState } from 'react';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { oneLine } from 'common-tags';

import DesktopMenu from '@/molecules/primarymenu/desktop';
import PreHeader from '@/molecules/primarymenu/desktop/PreHeader/PreHeader';
import MobileMenu from '@/molecules/primarymenu/mobile';
import ToastCenter from '@/organisms/toast-center';

import { useHeaderSticky } from '@/lib/hooks';
import { isCartRoute, isMyAccountRoute } from '@/lib/utils';

const LoginModal = dynamic(() => import('@/organisms/modals/LoginModal'), {
  ssr: false,
});

// TODO tipar los datos
export function Header() {
  const [open, setOpen] = useState(-1);
  const [openMobile, setOpenMobile] = useState(false);
  const [loginModalOpen, setLoginModalOpen] = useState(false);
  const [headerOutOfBounds, setHeaderOutOfBounds] = useState(false);
  const router = useRouter();
  const withOutSticky =
    isCartRoute(router.pathname) || isMyAccountRoute(router.pathname);

  const ref = useRef<HTMLDivElement>(null);

  useHeaderSticky(ref);

  useEffect(() => {
    const handleScroll = () => {
      if (ref.current) {
        setHeaderOutOfBounds(ref?.current?.getBoundingClientRect().bottom < 0);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <>
      <MobileMenu
        open={openMobile}
        setOpen={setOpenMobile}
        setOpenModal={setOpen}
        setLoginModalOpen={setLoginModalOpen}
        className={withOutSticky ? '' : 'sticky'}
      />

      <div
        ref={ref}
        className={oneLine`      
          ${withOutSticky ? '' : 'sticky'}
          top-0 z-50 transition-all
        `}
      >
        <div
          className={oneLine`
            fixed inset-0 -z-10 bg-gray-500 bg-opacity-75 backdrop-blur-sm transition-opacity
            ${open >= 0 ? 'opacity-100' : 'pointer-events-none opacity-0'}
          `}
          aria-hidden="true"
        />

        <div
          className={oneLine`
            z-50 h-full border-b-0 border-b-primary-100 bg-bg-primary lg:border-b
            ${withOutSticky ? '' : 'sticky'}
          `}
        >
          <header className="relative bg-bg-primary px-4">
            <PreHeader
              setLoginModalOpen={setLoginModalOpen}
              setOpen={setOpen}
            />
            <DesktopMenu open={open} setOpen={setOpen} />
          </header>

          <LoginModal
            show={loginModalOpen}
            setLoginModalOpen={setLoginModalOpen}
            onSuccess={() => setLoginModalOpen(false)}
          />
        </div>

        <ToastCenter
          className="hidden lg:block"
          {...(headerOutOfBounds && withOutSticky
            ? {
                style: {
                  position: 'fixed',
                  zIndex: -10,
                  width: '100%',
                  inset: 'auto',
                  top: 0,
                },
              }
            : {
                style: {
                  position: 'absolute',
                  zIndex: -10,
                  width: '100%',
                  inset: 'auto',
                },
              })}
        />
      </div>
    </>
  );
}
